import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="relative bg-[var(--brand)] text-white overflow-hidden">
      {/* Image Column - Full-bleed on the left */}
      <div className="lg:absolute lg:inset-y-0 lg:left-0 lg:w-1/2">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="relative h-[400px] lg:h-full w-full"
        >
          <img 
            src="https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/e2ebde4c-89cd-4999-9454-bc123b394614.jpg" 
            alt="Værtsparret bag Golf4Life" 
            className="absolute inset-0 w-full h-full object-cover"
          />
          
          {/* Overlay card */}
          <div className="absolute bottom-8 left-8 z-10 bg-white p-6 rounded-2xl shadow-xl">
            <div className="flex items-center gap-3 mb-1">
              <Heart className="text-[var(--brand)] fill-[var(--brand)]" size={20} />
              <span className="font-medium text-[var(--brand)]">Personligt & Trygt</span>
            </div>
            <p className="text-sm text-[var(--brand-90)] max-w-[240px] font-medium">
              Vi er selv til stede i Spanien og hjælper dig med alt det praktiske.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Content Column - Contained to follow the site's container line */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-start-2 pt-24 pb-16 lg:pt-32 lg:pb-24 lg:pl-16 xl:pl-24 text-slate-100"
          >
            <h2 className="text-3xl md:text-4xl font-medium mb-8 uppercase leading-tight">
              Personlige golfrejser med hjerte og nærvær
            </h2>
            <div className="space-y-6 text-lg leading-relaxed">
              <p>
                Golf4Life er et dansk rejsebureau, der arrangerer golfrejser og langtidsophold i Spanien – især omkring Cádiz og Costa de la Luz i Andalusien.
              </p>
              <p>
                Bag Golf4Life står et dansk ægtepar, som selv kender værdien af god tid, tryg planlægning og hyggeligt fællesskab. Her handler det ikke om store pakkerejser og samlebånd.
              </p>
              <p>
                Det handler om fleksible golfophold, hvor du kan nyde solen, banerne, kulturen og det gode selskab i dit eget tempo. Vi sørger for, at du føler dig hjemme fra det øjeblik, du lander.
              </p>
            </div>
            
            <div className="mt-10">
              <a 
                href="/om-os" 
                className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-white text-[var(--brand)] font-medium text-lg hover:-translate-y-1 transition-all shadow-lg"
              >
                Læs mere om os
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
